import { fetcher } from '@commenda/utils';

export async function deleteQuote(
  affiliateFirmId: string,
  quoteId: string
): Promise<Response | null> {
  try {
    const res = await fetcher(
      `affiliate-firms/${affiliateFirmId}/quotes/${quoteId}`,
      {
        method: 'DELETE',
      }
    );

    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}
